import React, { lazy } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";

import OAuth2RedirectHandler from "../Pages/Account/OAuth2RedirectHandler";
import CustomLoader from "../components/CustomLoader";

const Login = lazy(() => import("../Pages/Account/Login"));

const ResetPassword = lazy(() => import("../Pages/ResetPassword"));

const Admin = lazy(() => import("../Pages/Admin/Admin"));
const AdminDashboard = lazy(() => import("../Pages/Admin/AdminDashboard"));
const AdminMagicMapper = lazy(() => import("../Pages/Admin/AdminMagicMapper"));
const AdminMagicMapperNew = lazy(() => import("../Pages/Admin/AdminMagicMapperNew"));
const AdminMagicMapperDetails = lazy(() =>
  import("../Pages/Admin/AdminMagicMapperDetails")
);
const AdminMagicMapperDetailsNew = lazy(() =>
  import("../Pages/Admin/AdminMagicMapperDetailsNew")
);
const AdminUserRoleManagement = lazy(() => import("../Pages/Admin/AdminUserRoleManagement"));
const AdminStory = lazy(() => import("../Pages/Admin/AdminStory"));
const AdminReawards = lazy(() => import("../Pages/Admin/AdminReawards"));
const AdminAllCompanies = lazy(() => import("../Pages/Admin/AdminAllCompanies"));
const AdminCompanyAndBrandManagement = lazy(() => import("../Pages/Admin/AdminCompanyAndBrandManagement"));
const AdminProduct = lazy(() => import("../Pages/Admin/AdminProduct"));
const AdminCouponManagement = lazy(() => import("../Pages/Admin/AdminCouponManagement"));
const AdminOrderManagement = lazy(() => import("../Pages/Admin/AdminOrderManagement"));
const AdminNotification = lazy(() => import("../Pages/Admin/AdminNotification"));
const AdminAnalytics = lazy(() => import("../Pages/Admin/AdminAnalytics"));
// const AdminTenant = lazy(() => import("../Pages/Admin/AdminTenant"));
// const AdminCompany = lazy(()=> import("../Pages/Admin/AdminCompany"));
// const AdminEvents = lazy(() => import("../Pages/Admin/AdminEvents"));
// const AdminProspectiveSEOPages = lazy(() => import("../Pages/Admin/AdminProspectiveSEOPages"));
const AdminMarketing = lazy(() => import("../Pages/Admin/AdminMarketing"));
const Layout = lazy(() => import("../layout/Layout"));
const AdminWebsiteInfo = lazy(() => import("../Pages/Admin/AdminWebsiteInfo"));
const AdminCustomDomain = lazy(() =>
  import("../Pages/Admin/AdminCustomDomain")
);
const AdminSubscription = lazy(() => import("../Pages/Admin/AdminSubscription"));
const AdminSellerTracking = lazy(() => import("../Pages/Admin/AdminSellerTracking"));
const AdminServices = lazy(() => import('../Pages/Admin/AdminServices'));
const AdminLeadManagement = lazy(() => import('../Pages/Admin/AdminLeadManagement'));
const AdminGstManagement = lazy(() => import("../Pages/Admin/AdminGstManagement"));
const AdminSellerApprovals = lazy(() => import("../Pages/Admin/AdminSellerApprovals"));
const AdminQuote = lazy(() => import("../Pages/Admin/AdminQuote"));
const AdminWhatsappBusiness = lazy(() => import("../Pages/Admin/AdminWhatsappBusiness"));
const AdminCommentToDM = lazy(() => import("../Pages/Admin/AdminCommentToDM"));

const routeLogic = (roles) => {
  // if (roles != null) {
  //   if (roles === "ADMIN") {
  return (
    <>
      <Route exact path="/admin/home" element={<Admin />}></Route>
      {/* <Route
            exact
            path="/admin/dashboard"
            element={<AdminDashboard />}
          ></Route>
          <Route
            exact
            path="/admin/user-role-management"
            element={<AdminUserRoleManagement />}
          ></Route>
          <Route
            exact
            path="/admin/tenant-list"
            element={<AdminTenant />}
          ></Route>
          <Route
            exact
            path="/admin/company-list"
            element={<AdminCompany />}
          ></Route>
          <Route
            exact
            path="/admin/blogs"
            element={<AdminBlogPage />}></Route>
           <Route
            exact
            path="/admin/seopages"
            element={<AdminSEOPages />}></Route>
           <Route
            exact
            path="/admin/prospectiveseo"
            element={<AdminProspectiveSEOPages />}></Route>
             <Route
            exact
            path="/admin/marketing"
            element={<AdminMarketing />}></Route>
             <Route exact path="/admin/events" element={<AdminEvents />}></Route> */}

      <Route path="admin" element={<Layout />}>
        <Route index path="dashboard" element={<AdminDashboard />} />
        <Route path="user-role-management" element={<AdminUserRoleManagement />} />
        <Route path="story-rhymes-management" element={<AdminStory />} />
        <Route path="rewards-management" element={<AdminReawards />} />
        <Route path="company-brand-management" element={<AdminCompanyAndBrandManagement />} />
        <Route path="magic" element={<AdminMagicMapper />} />
        <Route path="magic/:customerId" element={<AdminMagicMapperDetails />} />
        <Route path="magic-new" element={<AdminMagicMapperNew />} />
        <Route path="magic-new/:customerId" element={<AdminMagicMapperDetailsNew />} />
        <Route path="all-companies" element={<AdminAllCompanies />} />
        <Route path="product-management" element={<AdminProduct />} />
        <Route path="coupon-management" element={<AdminCouponManagement />} />
        <Route path="orders-management" element={<AdminOrderManagement />} />
        <Route path="notifications" element={<AdminNotification />} />
        <Route path="analytics" element={<AdminAnalytics />} />
        {/* <Route path="tenant-list" element={<AdminTenant />} />
              <Route path="company-list" element={<AdminCompany />} /> */}
        <Route path="marketing" element={<AdminMarketing />} />
        <Route path="blogs" element={<Navigate to="/admin/marketing?tab=blog" replace />} />
        <Route path="seopages" element={<Navigate to="/admin/marketing?tab=seo" replace />} />
        {/* <Route
          path="domain"
          element={<AdminCustomDomain />}></Route> */}
        <Route
          path="website"
          element={<AdminWebsiteInfo />}></Route>
        <Route path="subscription" element={<AdminSubscription />}></Route>
        <Route path="seller-tracking-dashboard" element={<AdminSellerTracking />} />
        <Route path="approvals" element={<AdminSellerApprovals />} />
        <Route path="quote" element={<AdminQuote />} />
        <Route path="whatsapp-business" element={<AdminWhatsappBusiness />} />
        <Route path="comment-to-dm" element={<AdminCommentToDM />} />
        <Route path="quick-replies" element={<Navigate to="../whatsapp-business" replace />} />
        <Route path="services" element={<AdminServices />} />
        <Route path="lead-management" element={<AdminLeadManagement />} />
        <Route path="gst-management" element={<AdminGstManagement />} />
        {/* <Route path="prospectiveseo" element={<AdminProspectiveSEOPages />} /> */}
        {/* <Route path="events" element={<AdminEvents />} /> */}
      </Route>
    </>
  );
  //   }
  // }
};

function MainRouter(props) {
  // const dispatch = useDispatch();
  // const notification = useSelector((state) => state.notification);

  // useEffect();
  return (
    <Router>
      {/* <Notification
        type={notification.type}
        open={notification.Notification}
        message={notification.message}
        handleClose={() => {
          dispatch(offNotification());
        }}
      ></Notification> */}
      <React.Suspense fallback={<CustomLoader title={'Loading content'} subtitle={'Please wait while we prepare your workspace.'} />}>
        <Routes>
          {/* {sessionStorage.getItem("token") != null &&
            (jwt_decode(sessionStorage.getItem("token"))?.role
              ? routeLogic(jwt_decode(sessionStorage.getItem("token"))?.role)
              : routeLogic(null))} */}
          {routeLogic("ADMIN")}
          <Route exact path="/login" element={<Login />}></Route>
          <Route
            exact
            path="/resetpassword"
            element={<ResetPassword />}
          ></Route>
          {/* <Route exact path="/test" element={<Test />}></Route> */}
          <Route
            path="/oauth2/redirect"
            element={<OAuth2RedirectHandler />}
          ></Route>
          <Route exact path="*" element={<Login />} />
        </Routes>
      </React.Suspense>
    </Router>
  );
}

export default MainRouter;
